var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.5V27",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.403 7.49713L4.90749 35.9957C4.64354 36.4517 4.50434 36.9692 4.50391 37.4961C4.50347 38.023 4.64181 38.5407 4.905 38.9971C5.1682 39.4536 5.54697 39.8327 6.00319 40.0962C6.45942 40.3598 6.97702 40.4986 7.50392 40.4986H40.495C41.0219 40.4986 41.5395 40.3598 41.9957 40.0962C42.452 39.8327 42.8307 39.4536 43.0939 38.9971C43.3571 38.5407 43.4955 38.023 43.495 37.4961C43.4946 36.9692 43.3554 36.4517 43.0914 35.9957L26.5959 7.49713C26.3323 7.04185 25.9537 6.66387 25.498 6.4011C25.0423 6.13832 24.5255 6 23.9995 6C23.4734 6 22.9566 6.13832 22.5009 6.4011C22.0452 6.66387 21.6666 7.04185 21.403 7.49713Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36C25.2426 36 26.25 34.9926 26.25 33.75C26.25 32.5074 25.2426 31.5 24 31.5C22.7574 31.5 21.75 32.5074 21.75 33.75C21.75 34.9926 22.7574 36 24 36Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.62b94e3e80794478c5a3a73f6bac13fc.svg";
export { ForwardRef as ReactComponent };